import styled from "styled-components";
import "./styles.css"
import { useContext, useEffect, useState } from 'react';
import { GameContext } from '../../../../contexts/GameContext';
import { Values } from '../../../../interface/Values';
import { computeValueAvg, computeCumulAvg, computeFinalCumulAvg, computeFinalAvg } from '../../../../interface/Util';
import { computeScale } from '../../../../constants/utils';
import { ImageService } from '../../../../services/image/imageService';

interface Props {
    asset: keyof Values | "energy";
    caption: string | null;
    isGameEnd: boolean;
}


const ThreeLevelLabels = ["low", "mid", "high"];
const FiveLevelLabels = ["very-low", "low", "mid", "high", "very-high"];


const AnimationPlayer = ({ asset, caption, isGameEnd }: Props) => {
    const { interfaceParams, results, bounds, round } = useContext(GameContext);

    const [imageUrl, setImageUrl] = useState<string>("");

    useEffect(() => {
        if (interfaceParams) {
            const gradientValues: any[] = interfaceParams["bars"][asset]["gradient"];
            const hasThreeLevels = gradientValues.length === 3;

            let avgValue = 0;
            if (isGameEnd) {
                avgValue = (asset === "cost" || asset === "ges") ? computeFinalCumulAvg(results, asset, round) : computeFinalAvg(results, asset, round);
            } else {
                avgValue = (asset === "cost" || asset === "ges") ? computeCumulAvg(results, asset, round) : computeValueAvg(results, asset, round);
            }

            const scale = computeScale(avgValue, bounds[asset]["min"], bounds[asset]["max"]);
            for (let i = 1; i < gradientValues.length; ++i) {
                if (scale >= gradientValues[i]["threshold"]) {
                    continue;
                } else {
                    const beginName = asset + "-";
                    const imageUrl = ImageService.getImgUrl(beginName + (hasThreeLevels ? ThreeLevelLabels[i - 1] : FiveLevelLabels[i - 1]));
                    setImageUrl(imageUrl);
                    return;
                }
            }
            const beginName = asset + "-";
            const imageUrl = ImageService.getImgUrl(beginName + (hasThreeLevels ? ThreeLevelLabels[ThreeLevelLabels.length - 1] : FiveLevelLabels[FiveLevelLabels.length - 1]));
            setImageUrl(imageUrl);
        }

    }, [interfaceParams, results]);

    return (
        <Container>
            <img src={imageUrl} width={"250px"} height={"250px"} style={{"margin": "1em"}}/>
            {caption ? <h4>{caption}</h4> : null}
        </Container>
    );
};


const Container = styled.div`
    width: 100%;
    padding: auto;
    background-color: transparent;
    margin-left: auto;
    display: inline-block;
    text-align: center;
    color: black;
`;


export default AnimationPlayer;